import React from "react";
import { colors } from "@rosetta/react-common-ui";

var LowAudioWaveIcon = function LowAudioWaveIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? 142 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 14 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? colors.error : _ref$color;
  return React.createElement(
    "svg",
    { width: width, height: height, viewBox: "0 0 " + width + " " + height, fill: "none", "data-qa": "LowAudioWaveIcon" },
    React.createElement("rect", { y: 3, width: 6, height: 9, rx: 3, fill: color }),
    React.createElement("rect", { x: 9, y: 4, width: 6, height: 7, rx: 3, fill: color }),
    React.createElement("rect", { x: 18, width: 6, height: 14, rx: 3, fill: color }),
    React.createElement("rect", { x: 27, y: 4, width: 6, height: 7, rx: 3, fill: color }),
    React.createElement("rect", { x: 36, y: 4, width: 6, height: 6, rx: 3, fill: color }),
    React.createElement("rect", { x: 45, y: 2, width: 6, height: 10, rx: 3, fill: color }),
    React.createElement("rect", { x: 55, y: 4, width: 6, height: 7, rx: 3, fill: color }),
    React.createElement("rect", { x: 64, width: 6, height: 14, rx: 3, fill: color }),
    React.createElement("rect", { x: 73, y: 4, width: 6, height: 7, rx: 3, fill: color }),
    React.createElement("rect", { x: 82, y: 4, width: 6, height: 6, rx: 3, fill: color }),
    React.createElement("rect", { x: 91, y: 2, width: 6, height: 10, rx: 3, fill: color }),
    React.createElement("rect", { x: 100.064, y: 3, width: 6, height: 7.16667, rx: 3, fill: color }),
    React.createElement("rect", { x: 109, width: 6, height: 14, rx: 3, fill: color }),
    React.createElement("rect", { x: 118, y: 4, width: 6, height: 7, rx: 3, fill: color }),
    React.createElement("rect", { x: 127, y: 4, width: 6, height: 6, rx: 3, fill: color }),
    React.createElement("rect", { x: 136, width: 6, height: 14, rx: 3, fill: color })
  );
};

export default LowAudioWaveIcon;